// vuex
export default class MenuService {
  constructor(menu) {
    this.menu = menu
  }

  get data() {
    return this.menu
  }

  /**
   * @param {object} ctx
   * @param {object} ctx.title
   * @param {object} ctx.key
   * @param {object} ctx.icon
   * @param {object} ctx.url
   */
  removeAllItem() {
    this.menu = []
  }

  addItem(ctx) {
    this.menu.push(ctx)
  }
}
